export const DEFAULT_PER_PAGE = 100
export const PER_PAGE_OPTIONS = [5, 10, 20, 50, 100]

export const ORGANIZATION_TYPE = {
  CLIENT: 1,
  BPO: 2,
}
